import React from "react";
import { Outlet } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";

import { theme } from "./theme";
import ScreenProvider from "./providers/ScreenProvider";
import DataProvider from "./providers/DataProvider";
import SnackbarProvider from "./providers/SnackbarProvider";
import Inactivity from "./components/Inactivity";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ScreenProvider>
        <DataProvider>
          <SnackbarProvider>
            <Outlet />
            <Inactivity />
          </SnackbarProvider>
        </DataProvider>
      </ScreenProvider>
    </ThemeProvider>
  );
}
